import { fetchWithAuth } from './fetchWithAuth'

export async function updateInventorySystemProfile(
  token: string,
  id: string,
  body: Record<string, unknown>,
): Promise<void> {
  await fetchWithAuth(`/v1/inventory-system-profiles/${id}`, token, {
    method: 'PUT',
    body: JSON.stringify(body),
  })
}
